<template>
  <v-sheet color="strong" class="px-6 py-5">
    <v-row dense>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.maxNumberOfEntries"
          :label="$t('events:schedule.SetDailyLimit.label')"
          variant="outlined"
          :hint="$t('events:schedule.SetDailyLimit.hint')"
          persistent-hint
          class="fipa-filter-custom-input fipa-input-white-background"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.maxNumberOfAthletes"
          :label="
            $t(
              'events:schedule.SetDailyLimit.uniqueAthletes.label',
              'Daily limit for unique athletes'
            )
          "
          variant="outlined"
          :hint="
            $t(
              'events:schedule.SetDailyLimit.uniqueAthletes.hint',
              'Add maximum number of unique athletes for competition day'
            )
          "
          persistent-hint
          class="fipa-filter-custom-input fipa-input-white-background"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.maxNumberOfHorsesPerAthlete"
          :label="
            $t(
              'events:schedule.SetDailyLimit.maxNumberOfHorsesPerAthlete.label',
              'Daily limit for horses per athlete'
            )
          "
          variant="outlined"
          :hint="
            $t(
              'events:schedule.SetDailyLimit.maxNumberOfHorsesPerAthlete.hint',
              'Add maximum number of horses per athlete per day'
            )
          "
          persistent-hint
          class="fipa-filter-custom-input fipa-input-white-background"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.maxNumberOfEntriesPerHorse"
          :label="
            $t(
              'events:schedule.SetDailyLimit.maxNumberOfEntriesPerHorse.label',
              'Daily limit for entries horse can do'
            )
          "
          variant="outlined"
          :hint="
            $t(
              'events:schedule.SetDailyLimit.maxNumberOfEntriesPerHorse.hint',
              'Add maximum number of entries per horse per day'
            )
          "
          persistent-hint
          class="fipa-filter-custom-input fipa-input-white-background"
        />
      </v-col>
    </v-row>
    <template v-if="$vuetify.display.lgAndUp">
      <div class="mt-3 d-flex justify-end">
        <v-btn
          size="large"
          variant="outlined"
          :disabled="loading"
          min-width="160px"
          class="mr-3"
          @click="dialog = false"
        >
          {{ $t("common:button.cancel", "Cancel", "Cancel button") }}
        </v-btn>
        <v-btn
          size="large"
          min-width="160px"
          color="accent"
          :loading="loading"
          :disabled="loading"
          @click="handleSubmit()"
        >
          {{ $t("common:button.save", "Save", "Save button") }}
        </v-btn>
      </div>
    </template>
    <div v-else class="d-flex flex-column" style="align-items: center">
      <v-btn
        variant="outlined"
        :disabled="loading"
        rounded
        class="mb-5 mt-2"
        max-width="295px"
        width="100%"
        @click="dialog = false"
      >
        {{ $t("common:button.cancel", "Cancel", "Cancel button") }}
      </v-btn>

      <v-btn
        max-width="295px"
        rounded
        width="100%"
        color="accent"
        :loading="loading"
        :disabled="loading"
        @click="handleSubmit()"
      >
        {{ $t("common:button.save", "Save", "Save button") }}
      </v-btn>
    </div>
  </v-sheet>
</template>
<script>
import gql from "fraql";
export default {
  name: "CompetitionDayLimitsForm",
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    eventLimit: {
      type: Object,
      default: () => ({
        id: null,
        maxNumberOfEntries: 0,
        maxNumberOfEntriesPerHorse: 0,
        maxNumberOfAthletes: 0,
        maxNumberOfHorsesPerAthlete: 0
      })
    },
    competitionDayNumber: {
      type: Number,
      required: true
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      loading: false,
      form: {
        maxNumberOfEntries: 0,
        maxNumberOfEntriesPerHorse: 0,
        maxNumberOfAthletes: 0,
        maxNumberOfHorsesPerAthlete: 0
      }
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  beforeMount() {
    this.form = {
      maxNumberOfEntries: this.eventLimit.maxNumberOfEntries,
      maxNumberOfEntriesPerHorse: this.eventLimit.maxNumberOfEntriesPerHorse,
      maxNumberOfAthletes: this.eventLimit.maxNumberOfAthletes,
      maxNumberOfHorsesPerAthlete: this.eventLimit.maxNumberOfHorsesPerAthlete
    };
  },
  methods: {
    handleSubmit() {
      this.loading = true;
      this.form.maxNumberOfEntries = Number(this.form.maxNumberOfEntries);
      this.form.maxNumberOfEntriesPerHorse = Number(
        this.form.maxNumberOfEntriesPerHorse
      );
      this.form.maxNumberOfAthletes = Number(this.form.maxNumberOfAthletes);
      this.form.maxNumberOfHorsesPerAthlete = Number(
        this.form.maxNumberOfHorsesPerAthlete
      );

      if (
        !this.form.maxNumberOfEntries ||
        Number.isNaN(this.form.maxNumberOfEntries) ||
        this.form.maxNumberOfEntries <= 0
      ) {
        this.form.maxNumberOfEntries = null;
      }
      if (
        !this.form.maxNumberOfEntriesPerHorse ||
        Number.isNaN(this.form.maxNumberOfEntriesPerHorse) ||
        this.form.maxNumberOfEntriesPerHorse <= 0
      ) {
        this.form.maxNumberOfEntriesPerHorse = null;
      }
      if (
        !this.form.maxNumberOfAthletes ||
        Number.isNaN(this.form.maxNumberOfAthletes) ||
        this.form.maxNumberOfAthletes <= 0
      ) {
        this.form.maxNumberOfAthletes = null;
      }

      if (
        !this.form.maxNumberOfHorsesPerAthlete ||
        Number.isNaN(this.form.maxNumberOfHorsesPerAthlete) ||
        this.form.maxNumberOfHorsesPerAthlete <= 0
      ) {
        this.form.maxNumberOfHorsesPerAthlete = null;
      }

      if (this.eventLimit.id) {
        this.updateEventLimit();
      } else {
        this.createEventLimit();
      }
    },
    async createEventLimit() {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation eventLimitCreate(
              $eventId: ID!
              $limitScope: String!
              $maxNumberOfEntries: Int
              $maxNumberOfEntriesPerHorse: Int
              $maxNumberOfAthletes: Int
              $competitionDayNumber: Int
              $maxNumberOfHorsesPerAthlete: Int
            ) {
              eventLimitCreate(
                input: {
                  eventId: $eventId
                  limitScope: $limitScope
                  maxNumberOfEntries: $maxNumberOfEntries
                  maxNumberOfEntriesPerHorse: $maxNumberOfEntriesPerHorse
                  maxNumberOfAthletes: $maxNumberOfAthletes
                  competitionDayNumber: $competitionDayNumber
                  maxNumberOfHorsesPerAthlete: $maxNumberOfHorsesPerAthlete
                }
              ) {
                eventLimit {
                  id
                  limitScope
                  competitionDayNumber

                  maxNumberOfEntries
                  entriesRegistrationConfirmedCount

                  maxNumberOfEntriesPerHorse

                  maxNumberOfAthletes
                  athletesRegistrationConfirmedCount

                  maxNumberOfHorsesPerAthlete
                  allowedMutations
                }
              }
            }
          `,
          refetchQueries: [
            {
              query: gql`
                query eventRefetchEventLimitsAndCompetitionStatus($id: ID) {
                  event(id: $id) {
                    id
                    competitions {
                      id
                      status
                      limitEntriesForPublicRegistration
                      maxNumberOfHorsesPerAthlete
                      maxNumberOfEntriesPerHorse
                      publicRegistrationsDisabled
                    }
                    eventLimits {
                      id
                      limitScope
                      competitionDayNumber

                      maxNumberOfEntries
                      entriesRegistrationConfirmedCount

                      maxNumberOfEntriesPerHorse

                      maxNumberOfAthletes
                      athletesRegistrationConfirmedCount

                      maxNumberOfHorsesPerAthlete
                      allowedMutations
                    }
                  }
                }
              `,
              variables: {
                id: this.eventId
              }
            }
          ],
          variables: {
            eventId: this.eventId,
            limitScope: "COMPETITION_DAY",
            competitionDayNumber: this.competitionDayNumber,
            maxNumberOfEntries: this.form.maxNumberOfEntries
              ? this.form.maxNumberOfEntries
              : null,
            maxNumberOfEntriesPerHorse: this.form.maxNumberOfEntriesPerHorse
              ? this.form.maxNumberOfEntriesPerHorse
              : null,
            maxNumberOfAthletes: this.form.maxNumberOfAthletes
              ? this.form.maxNumberOfAthletes
              : null,
            maxNumberOfHorsesPerAthlete: this.form.maxNumberOfHorsesPerAthlete
              ? this.form.maxNumberOfHorsesPerAthlete
              : null
          }
        });
        this.dialog = false;
      } catch (error) {
        this.$root.$snackbarServerError(error, { level: "error" });
      } finally {
        this.loading = false;
      }
    },
    async updateEventLimit() {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation eventLimitUpdate(
              $id: ID!
              $maxNumberOfEntries: Int
              $maxNumberOfEntriesPerHorse: Int
              $maxNumberOfAthletes: Int
              $competitionDayNumber: Int
              $maxNumberOfHorsesPerAthlete: Int
            ) {
              eventLimitUpdate(
                input: {
                  id: $id
                  maxNumberOfEntries: $maxNumberOfEntries
                  maxNumberOfEntriesPerHorse: $maxNumberOfEntriesPerHorse
                  maxNumberOfAthletes: $maxNumberOfAthletes
                  competitionDayNumber: $competitionDayNumber
                  maxNumberOfHorsesPerAthlete: $maxNumberOfHorsesPerAthlete
                }
              ) {
                eventLimit {
                  id
                  limitScope
                  competitionDayNumber

                  maxNumberOfEntries
                  entriesRegistrationConfirmedCount

                  maxNumberOfEntriesPerHorse

                  maxNumberOfAthletes
                  athletesRegistrationConfirmedCount

                  maxNumberOfHorsesPerAthlete
                  allowedMutations
                }
              }
            }
          `,
          refetchQueries: [
            {
              query: gql`
                query eventRefetchCompetitionsStatuses($id: ID) {
                  event(id: $id) {
                    id
                    competitions {
                      id
                      status
                      limitEntriesForPublicRegistration
                      maxNumberOfHorsesPerAthlete
                      maxNumberOfEntriesPerHorse
                      publicRegistrationsDisabled
                    }
                  }
                }
              `,
              variables: {
                id: this.eventId
              }
            }
          ],
          variables: {
            id: this.eventLimit.id,
            competitionDayNumber: this.competitionDayNumber,
            maxNumberOfEntries: this.form.maxNumberOfEntries
              ? this.form.maxNumberOfEntries
              : null,
            maxNumberOfEntriesPerHorse: this.form.maxNumberOfEntriesPerHorse
              ? this.form.maxNumberOfEntriesPerHorse
              : null,
            maxNumberOfAthletes: this.form.maxNumberOfAthletes
              ? this.form.maxNumberOfAthletes
              : null,
            maxNumberOfHorsesPerAthlete: this.form.maxNumberOfHorsesPerAthlete
              ? this.form.maxNumberOfHorsesPerAthlete
              : null
          }
        });
        this.dialog = false;
      } catch (error) {
        this.$root.$snackbarServerError(error, { level: "error" });
      } finally {
        this.loading = false;
      }
    }
  },
  fragments: {
    competitionDayLimitsFormFields: gql`
      fragment _ on EventLimit {
        id
        limitScope
        competitionDayNumber
        maxNumberOfEntries
        maxNumberOfEntriesPerHorse
        maxNumberOfAthletes
        maxNumberOfHorsesPerAthlete
      }
    `
  }
};
</script>
